type VersionRow = { _id: string };

export type MergedVersions<T> = T & { inDraft: boolean; inPublished: boolean };

const DRAFTS_PREFIX = "drafts.";

// One entry per document: the draft row wins because it is what the editor opens.
export const mergeVersions = <T extends VersionRow>(
  rows: T[]
): MergedVersions<T>[] => {
  const documents = new Map<string, MergedVersions<T>>();

  for (const row of rows) {
    const isDraft = row._id.startsWith(DRAFTS_PREFIX);
    const id = isDraft ? row._id.slice(DRAFTS_PREFIX.length) : row._id;
    const existing = documents.get(id);

    documents.set(id, {
      ...(isDraft || !existing ? row : existing),
      inDraft: isDraft || !!existing?.inDraft,
      inPublished: !isDraft || !!existing?.inPublished
    });
  }

  return [...documents.values()];
};
